module.exports = __webpack_public_path__ + "static/media/download-iphone.5fda9570.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jornaleiro/download-iphone.jpg
// module id = 968
// module chunks = 0